let dateFormat = "DD-MM-YYYY"

export const DATEFORMAT = dateFormat;



// WEBPACK FOOTER //
// ./src/date-config.js